import script from "./Inbound.vue?vue&type=script&setup=true&lang=js"
export * from "./Inbound.vue?vue&type=script&setup=true&lang=js"

import "./Inbound.vue?vue&type=style&index=0&id=3174dbbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3174dbbd"]])

export default __exports__